import styled from 'styled-components';
import Img from '../Img';

const StyledImg = styled(Img)<{ height: number }>`
  height: ${({ height }) => height}px;
`;

export default StyledImg;
